import React from "react";
import { createRoot } from 'react-dom/client';
import ErrorBox from "../../common/ErrorBox";
import { useState, useEffect } from "react";
import { ConfigProvider, Modal, App, Tabs } from 'antd';
import { EditableContextProvider } from "../../common/EditableContextProvider";
import { customTheme } from "../../common/customTheme";
import { useCasos } from "../../admin/casos/useCasos";
import { TableComponent } from "./TableComponent";
import { ModalPasosTitular } from "./ModalPasosTitular";
import { ModalDocumentosTitular } from "./ModalDocumentosTitular";
import { ModalPagos } from "./ModalPagos";

export default function MainTitular() {
    const context = useCasos();

    useEffect(() => {
        Promise.all([context.casos.fillResources(), context.casos.fillItems()]);
    }, []);

    return (
        <div>
            <EditableContextProvider data={{
                ...context
            }}
            >
                <TableComponent />
                <ModalPasosTitular />
                <ModalPagos />
                <ModalDocumentosTitular />

            </EditableContextProvider>
        </div>
    );
}

let main = document.getElementById('casos-titular-main');
if (main) {
    const root = createRoot(main);
    root.render(
        <React.StrictMode>
            <ErrorBox>
                <ConfigProvider theme={customTheme}>
                    <App>
                        <MainTitular />
                    </App>
                </ConfigProvider>
            </ErrorBox>
        </React.StrictMode>
    );
}
